import { subscribe } from "../emitter-subscriber/subscribe";
import { handleError } from "../utils/handle-error";
const config = () => {
    let mutationObserver;
    const delayCheck = 500;
    const unobserveSubscription = () => {
        subscribe("AAT_UNOBSERVE_UPDATES", (payload) => {
            if (mutationObserver)
                mutationObserver.disconnect();
        });
    };
    const observeSubscription = () => {
        subscribe("AAT_OBSERVE_UPDATES", (payload) => {
            if (!payload)
                return;
            const delay = 1000; // Delay in milliseconds
            const observedElement = document.querySelector(`.${payload}`);
            // console.log(experienceName);
            // console.log(observedElement);
            mutationObserver = new MutationObserver((mutations) => {
                for (var index = 0; index < mutations.length; index++) {
                    const { type, addedNodes } = mutations[index];
                    if (type === "childList" && addedNodes.length) {
                        // @ts-ignore
                        aat("observeElements");
                        // Disconnect the observer
                        mutationObserver.disconnect();
                        // Reattach the observer after a delay
                        setTimeout(() => {
                            if (observedElement) {
                                mutationObserver.observe(observedElement, {
                                    childList: true,
                                    subtree: true,
                                });
                            }
                        }, delayCheck);
                        break;
                    }
                }
            });
            const [metaError, metaResult] = handleError(() => {
                if (observedElement)
                    mutationObserver.observe(observedElement, {
                        childList: true,
                        subtree: true,
                    });
            });
            if (metaError) {
                console.warn("[Tracking] Error parsing template:", metaError);
            }
        });
    };
    return { observeSubscription, unobserveSubscription };
};
export const { observeSubscription, unobserveSubscription } = config();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/observer.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/observer.js
// module chunks = 0